module.exports = __webpack_public_path__ + "media/images/phone-3eded2c5a8459548271a95c162c087bc.jpg";